import { Directive, HostListener, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Directive({
  selector: '[formatInitials]'
})
export class FormatInitialsDirective {
  @Input() public formControl: FormControl;
  @Input() public formatInitials: any;

  @HostListener('input', ['$event'])
  public format(event: InputEventWrapper): string {
      const isIEorEdge = FormatInitialsDirective.isIEorEdge();

    if (!isIEorEdge) {// if default modern browser (not IE) then ensure good formatting with dots.
      const { target } = event;
      const originalValue = (target as HTMLInputElement).value;
      // tslint:disable

      // indien backspace, dan explicit het teken weghalen (anders werkt de backspace niet)
      const isBackSpace = event.inputType === 'deleteContentBackward';
      if (isBackSpace) {
        return originalValue.substring(0, originalValue.length - 2);
      }

      const formattedValue = FormatInitialsDirective.formatString(originalValue);
      const inputValue = formattedValue === this.formatInitials ? originalValue : formattedValue;

      (target as HTMLInputElement).value = inputValue;
      this.formControl.setValue(inputValue);
    }
}


  public static isIEorEdge():boolean {
    return navigator.appName.toLowerCase().includes('microsoft') ||
      navigator.userAgent.toLowerCase().includes('edge')  ||
      navigator.userAgent.toLowerCase().includes('trident');
  }

  public static formatString(value: string): string {
    if (!value) {
      return value;
    }
    const withDots = value
      .toUpperCase()
      .split('')
      .filter(letter => letter !== '.')
      .join('.');

    return `${withDots}${withDots.split('').length ? '.' : ''}`;
  }
}

